import React, { useEffect } from 'react';

import isEmpty from 'lodash/isEmpty';

import {
  View,
  Stack,
  Select,
  Typography,
  Iframe,
  LazyLoadImage,
} from '@gogame/components';
import { useMountedState } from '@gogame/hooks-ts';

const TYPE_PDF = 'Pdf';

const Attachments = ({ data, isLoading, isRefetching, dense = true }) => {
  const [selectedAttachment, setSelectedAttachment] = useMountedState(null);

  useEffect(() => {
    setSelectedAttachment(data?.[0]);
  }, [data]);

  const handleAttachmentChange = (_e, value) => {
    data.forEach(async (attachment) => {
      if (attachment.id === value) {
        setSelectedAttachment(attachment);
      }
    });
  };

  return (
    <View
      loading={isLoading}
      fetching={isRefetching}
      transparent={true}
      grow={true}
    >
      <Stack spacing={2} flex={'1 1 auto'} height={'100%'} p={dense ? 0 : 2}>
        {data?.length && selectedAttachment && data?.length !== 1 ? (
          <Stack width={'50%'}>
            <Select
              value={selectedAttachment.id}
              onChange={handleAttachmentChange}
              options={data}
            />
          </Stack>
        ) : null}
        {!isEmpty(selectedAttachment) ? (
          <Stack minHeight={'100px'}>
            {selectedAttachment.type === TYPE_PDF ? (
              <Iframe
                src={selectedAttachment.url}
                width={'100%'}
                height={'calc(100vh - 264px)'}
              />
            ) : (
              <LazyLoadImage src={selectedAttachment.url} />
            )}
          </Stack>
        ) : (
          <Stack
            alignItems={'center'}
            justifyContent={'center'}
            flex={'1 1 auto'}
          >
            <Typography color={'textSecondary'}>No attachments</Typography>
          </Stack>
        )}
      </Stack>
    </View>
  );
};

export default Attachments;
